import styled, { css } from 'styled-components'

import { maxmedia, minmedia } from '../../styles/media-queries'
import { Container } from '../../styles/defaults'
import { black, gold } from '../../styles/colors'

export const BreadcrumbContainer = Container.extend`
  margin-top: 0.25rem;

  ${maxmedia.large`
    display: none;
  `}

  ${props => props.fill && css`
    text-align: right;
    padding-top: 1rem;
    padding-bottom: 2rem;

    ${minmedia.xmlarge`
      padding-bottom: 6rem;
    `}
  `}
`

export const Crumb = styled.span`
  font-size: 16px;

  &:after {
    content: '>';
    padding: 0 .3rem;
  }

  a {
    color: ${black}
    text-decoration: none;
    &:hover {
      color: ${gold};
    }
  }
`

export const LastCrumb = styled.span`
  font-size: 16px;
  font-weight: 500;
`


// WEBPACK FOOTER //
// ./src/components/Breadcrumb/styles.js